const modelName = 'Search Filter Prices';
const modelNameSingular = 'Search Filter Price';
const endpoint = '/search-filter-price';

const setup = {
    title: modelName,
    singular: modelNameSingular,
    model: modelName.replace(/\s+/g, '-').toLowerCase(),
    canDelete: true,
    canAddNew: true,
    canSearch: true,
    endpoint,
    accessor: 'id',
};

export default setup;
